import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { StarBackground } from './components/StarBackground';
import { Header } from './components/Header';
import { AuthInit } from './components/AuthInit';
import { HomePage } from './pages/HomePage';
import { PostPage } from './pages/PostPage';
import { LibraryPage } from './pages/LibraryPage';
import { ProfilePage } from './pages/ProfilePage';
import { RssPage } from './pages/RssPage';
import { OAuthCallback } from './pages/OAuthCallback';
import { AdminPage } from './pages/admin/AdminPage';
import { EditorPage } from './pages/admin/EditorPage';
import { AdminProfilePage } from './pages/admin/AdminProfilePage';
import { AdminHeroPage } from './pages/admin/AdminHeroPage';
import { AdminLayout } from './pages/admin/AdminLayout';
import { ErrorBoundary } from './components/ErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <BrowserRouter>
          <AuthInit>
            <StarBackground>
              <Header />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/posts/:slug" element={<PostPage />} />
                <Route path="/library" element={<LibraryPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/about" element={<Navigate to="/profile" replace />} />
                <Route path="/rss" element={<RssPage />} />
                <Route path="/archive" element={<Navigate to="/library" replace />} />
                <Route path="/tags" element={<Navigate to="/library" replace />} />
                <Route path="/oauth/callback" element={<OAuthCallback />} />
                <Route element={<AdminLayout />}>
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/admin/new" element={<EditorPage />} />
                  <Route path="/admin/edit/:id" element={<EditorPage />} />
                  <Route path="/admin/profile" element={<AdminProfilePage />} />
                  <Route path="/admin/about" element={<Navigate to="/admin/profile" replace />} />
                  <Route path="/admin/hero" element={<AdminHeroPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </StarBackground>
          </AuthInit>
        </BrowserRouter>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
